<template lang="pug">
div
    .modal-cancelar-suspender-imovel
        .subtitle CAR: {{ codigoImovel }}
        select-filter-component.campo-form(
            :list='motivos',
            label='Motivo:',
            fieldLabel='Motivo*:'
            placeholder='Selecione o motivo',
            :filterable='false',
            @change='selecionarMotivo',
            chave='nome'
        )
        text-input-component(style='padding-bottom: 20px;'
            v-if='exibeNumeroDocumento', v-model='form.numeroDocumento', label='Número do documento*:')
        span Cópia digital
        span {{ form.motivo === 'DECISAO_JUDICIAL' ? '*:' : ':' }}
        ButtonUploadComponent(
            ref='upload',
            texto='Arquivo',
            :dadosExtra='{ caminhoDestino : this.destinoDocumento[this.acao].nome }'
            @file-upload='file => uploadAnexo(file)',
            @file-removed='removerAnexo',
        )
        text-area-input-component.campo-form(
            v-model='form.justificativa',
            label='Justificativa*:',
            placeholder=''
        )
        el-divider
    .rodape
        button-component.botao-cancelar(label='Cancelar', icon='mdi-close', @click.native='$emit("close")')
        button-component(label='Confirmar', icon='mdi-check', @click.native='salvar')
</template>

<script>
import ButtonUploadComponent from '@/components/ButtonUploadComponent.vue';
import { cancelarImovel, suspenderImovel, reverterSuspensaoImovel } from '@/services/imovel.service'

export default {
    components: {
        ButtonUploadComponent
    },
    props: {
        codigoImovel: {
            type: String,
            required: true,
        },
        acao: {
            type: String,
            required: true,
        },
        idProcesso: {
            type: Number,
            required: true,
        }
    },
    data() {
        return {
            motivos: [
                { id: 0, nome: 'Decisão Judicial', selecionado: false, codigo: 'DECISAO_JUDICIAL' },
                { id: 1, nome: 'Decisão Administrativa', selecionado: false, codigo: 'DECISAO_ADMINISTRATIVA'},
            ],
            destinoDocumento: {
                CANCELAR_IMOVEL: {
                    nome: 'cancelamento-imovel',
                },
                SUSPENDER_IMOVEL: {
                    nome: 'suspensao-imovel',
                },
                REVERTER_SUSPENSAO_IMOVEL: {
                    nome: 'reversao-suspensao-imovel'
                }
            },
            form: {
                justificativa: null,
                motivo: null,
                anexo: null,
            },
            exibeNumeroDocumento: false,
        };
    },
    methods: {
        async salvar() {
            const { justificativa, motivo, anexo, numeroDocumento } = this.form;

            const camposInvalidos = !justificativa || justificativa === '' ||
                !motivo || (motivo === 'DECISAO_JUDICIAL' && (!anexo || !numeroDocumento || numeroDocumento === ''));
            
            if (camposInvalidos) {
                this.$notify({
                    title: 'Erro!',
                    message: 'Verifique os campos obrigatórios antes de prosseguir.',
                    showClose: true,
                    type: 'error'
                });
                return;
            }
            
            try {
                this.form.idProcesso = this.idProcesso;
                if (this.acao === 'CANCELAR_IMOVEL') {
                    await cancelarImovel(this.form);
                } else if (this.acao === 'SUSPENDER_IMOVEL') {
                    await suspenderImovel(this.form);
                } else if (this.acao === 'REVERTER_SUSPENSAO_IMOVEL') {
                    await reverterSuspensaoImovel(this.form);
                }

                this.$emit('atualizar');
                this.form = {
                    justificativa: null,
                    motivo: null,
                    anexo: null,
                },

                this.$notify({
                    title: 'Sucesso!',
                    message: 'O status do imóvel foi alterado com sucesso!',
                    showClose: true,
                    type: 'success'
                });
            } catch (error) {
                let mensagem = null;
                if (error?.message) {
                    mensagem = error.message;
                }
                this.$notify({
                    title: 'Erro!',
                    message: mensagem ||'Ocorreu um erro ao tentar concluir.',
                    showClose: true,
                    type: 'error'
                });
            }

        },
        selecionarMotivo(motivo) {
            const motivoSelecionado = this.motivos.find(m => m.nome === motivo);
            this.form.numeroDocumento = null;
            this.exibeNumeroDocumento = motivoSelecionado?.codigo === 'DECISAO_JUDICIAL';
            this.form.motivo = motivoSelecionado ? motivoSelecionado.codigo : null;
        },
        uploadAnexo(file) {
            this.form.anexo = file;
        },
        removerAnexo() {
            this.form.anexo = null;
        },
    },
};
</script>

<style scoped lang="scss">
.subtitle {
    margin-top: 20px;
    font-weight: bold;
    font-size: 15px;
    color: #3d3d3d;
}

.campo-form {
    padding: 20px 0px;
}

.botao-cancelar {
    background-color: #ddd !important;
    color: #666 !important;
}

.rodape {
    display: flex;
    justify-content: space-between;
}

</style>
